import { observer } from 'mobx-react-lite';
import cn from 'classnames';
import Checkbox from '../../../ui/checkbox';
import { CustomFilterBodyProps } from '../customFilter.type';
import styles from './styles.module.scss';

const CheckboxList: React.FC<CustomFilterBodyProps> = observer(
  ({ childs, handleChange = () => {} }) => (
    <div className={styles.container}>
      {childs?.map((child: any, i: number) => (
        <div key={i} className={styles.filterSectionSettingContainer}>
          <Checkbox
            checked={child.selected}
            onChanges={() => {
              handleChange(childs, child);
            }}
          >
            <p className={cn(styles.filterSectionSetting, styles.category)}>
              {child.name}
            </p>
          </Checkbox>
        </div>
      ))}
    </div>
  ),
);

export default CheckboxList;
